import React, {useLayoutEffect} from 'react'

import PopupMenuButton from "../../popover-menu/popup-menu-button/popup-menu-button"
import {PinData} from "../../../model2/pin/@types"
import PinMenu from "./menu"
import ControlButtonStandard, {ControlButtonType} from "../../buttons/control-button/control-button-standard"
import {useForceUpdate} from "../../../gd/utils/dom-and-react/react-utils"
import {SESSION_PINS_CHANGED} from "../../../gd/bus/bus-event-type"

type Props = {
    className?          : string

    data                : PinData

    disabled?           : boolean

    onTogglePopover?    : func
}

// const debug = "Pin"
const debug = false

export default function Pin(props: Props) {

    const forceUpdate = useForceUpdate()

    useLayoutEffect(()=>{
        return gd.bus.subscribeNoContext(SESSION_PINS_CHANGED, forceUpdate)
    }, [])

    const renderButton = (state: any) =>
        <ControlButtonStandard className     = {Classes({'show-popover': state.showPopover})}
                               type          = {!!gd.session.pins.getPinId(props.data) ? ControlButtonType.UNPIN : ControlButtonType.PIN}
                               isDisabled    = {props.disabled}/>

    if (props.disabled || gd.user.isCustomer()) return null

    return <PopupMenuButton className           = {props.className}
                            btnComponent        = {renderButton}
                            attachment          = "top center"
                            targetAttachment    = "bottom center"
                            offset              = "0 0"
                            menuComponent       = {PinMenu}
                            menuParams          = {{
                                data    : props.data,
                            }}
                            disabled            = {props.disabled}
                            onTogglePopover     = {props.onTogglePopover}/>
}